import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../config/API";

const USERS_ENDPOINT = "/login.php";

// Login thunk to validate login
const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (credentials, thunkAPI) => {
    try {
      const response = await axiosInstance.post(USERS_ENDPOINT, {
        action: "login",
        phone: credentials.email,
        password: credentials.password,
      });

      if (response?.data?.head?.code === 200) {
        const userData = response?.data?.body?.user || {};
        localStorage.setItem("user", JSON.stringify(userData));

        return userData;
      } else {
        return thunkAPI.rejectWithValue(
          response?.data?.head?.msg || "Invalid login details"
        );
      }
    } catch (error) {
      console.error("Login Error:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const logoutUser = createAsyncThunk("auth/logoutUser", async (_, thunkAPI) => {
  localStorage.removeItem("user");
  return {};
});

export { loginUser, logoutUser };
